'use strict';

module.exports = require('./index').default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/requestanimationframe-timer/dist/cjs.js
// module id = 478
// module chunks = 0